import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DashBoard from './Components/DashBoard.jsx';
import Loader from "./widgets/Loader.jsx";
import { LoaderProvider } from "./context/LoaderContext.jsx";

function App() {
  document.body.style.margin = "0";
  document.body.style.padding = "0";

  return (
    <LoaderProvider>
      <Router>
        <Loader />
        <Routes>
          <Route path="/" element={<DashBoard />} />
          <Route path="/dashboard" element={<DashBoard />} />
        </Routes>
      </Router>
    </LoaderProvider>
  );
}

export default App;
